<div mat-dialog-content [formGroup]="FormPayorAdd">
  <mat-form-field appearance="fill">
    <mat-label>Select an Payor</mat-label>
    <mat-select formControlName="PayorId">
      <mat-option *ngFor="let item of PlaceOrderCustomer" [value]="item.key"
        >{{ item.value }}</mat-option
      >
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button (click)="OnAddPayorId()">Add</button>
</div>
